import React, { useState } from "react";
import axios from "axios";
import Header from "../../Components/Header/Header";
import { InputText } from "primereact/inputtext";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            await axios.post(
                `${process.env.REACT_APP_BASE_URL_API}/forgot-password`,
                { email }
            );

            setIsError(false);
            setMessage("Si cet email existe, un lien de réinitialisation a été envoyé.");
        } catch (error) {
            setIsError(true);

            setMessage(
                error.response?.status === 400
                    ? "Si un compte correspond à cette adresse, un lien de réinitialisation a été envoyé."
                    : "Une erreur est survenue, merci de réessayer plus tard."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <div className="contactPage forgot_password text-center">
                <h2>Vous avez oublié votre mot de passe ?</h2>

                <p>
                    Nous allons vous envoyer la marche à suivre par e-mail.
                    C&apos;est simple et rapide.
                </p>

                <form onSubmit={handleSubmit}>
                    <div className="form_columns">
                        <div className="field">

                            <label htmlFor="email">
                                <b>Adresse e-mail</b>
                            </label>

                            <br /><br />

                            <InputText
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Votre email"
                                type="email"
                                className="forgot_password_email"
                                required
                            />

                            <br /><br />

                            <button
                                type="submit"
                                className="btn btn-danger text-lg-end"
                                disabled={loading}
                            >
                                {loading ? "Envoi en cours…" : "Envoyer"}
                            </button>

                            {message && (
                                <p>
                                    {isError ? (
                                        <small className="p-error">
                                            {message}
                                        </small>
                                    ) : (
                                        message
                                    )}
                                </p>
                            )}

                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;